import React, {Component, Fragment} from 'react';
import classNames from 'classnames';
import './DashboardTasks.scss';
import LoadingButton from "../../../shared/ui/LoadingButton";
import {formatDate} from "../../../shared/services/utils/utils";
import {FormGroup, Input} from "reactstrap";
import Modal from "../../../shared/ui/Modal";

class DashboardTasks extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      taskGroup: null
    };
  }

  get taskResponse() {
    const nextTaskResponse = this.nextTaskResponse(this.props.taskResponses);

    return nextTaskResponse;
  }

  get taskGroup() {
    if (this.taskResponse && this.props.taskGroupsMap) {
      return this.props.taskGroupsMap[this.taskResponse.task.guid];
    }

    return this.state.taskGroup;
  }

  nextTaskResponse(taskResponses) {
    let tr = taskResponses
      && taskResponses.sort((tr1, tr2) => {
        const date1 = new Date(tr1.actionAt).getTime();
        const date2 = new Date(tr2.actionAt).getTime();

        if (date1 < date2) {
          return -1;
        } else if (date1 > date2) {
          return 1;
        }
        return 0;
      });

    if(tr) {
      return tr.length > 0? tr[0]: null;
    } else {
      return null;
    }
  };

  showReferenceMaterial(taskResponse) {
    this.setState({
      isModalOpen: true,
      taskGroup: this.props.taskGroupsMap[taskResponse.task.guid]
    });
  }

  render() {
    return (
      <div className={classNames("dashboard-tasks", "card", {'has-warnings': this.props.hasWarnings})}>
        <div className="header">
          <i className={`fa fa-${this.props.icon}`} />
          <span>
              {this.props.title} ({this.props.taskResponses
            ? this.props.taskResponses.length
            : 0})
            </span>
        </div>
        {this.taskResponse && (
          <div className="next-task">
            <div className="heading">Next task for acknowledgement</div>
            <div className="next-task-content">
              <div className="info">
                <div>
                  <b>{this.taskResponse.task.prompt}</b>
                </div>
                <div>
                  <b className="action">{this.taskResponse.action}</b> by <b>{this.taskResponse.author.name}</b> on <b>{formatDate(this.taskResponse.actionAt)}</b>
                </div>
              </div>
            </div>
            {this.taskResponse.authorComment && (
              <Fragment>
                <div><b>Notes</b></div>
                <div style={{fontSize: '0.8em', padding: '10px 0'}}>
                  {this.taskResponse.authorComment}
                </div>
                {this.taskResponse.substandard && (
                  <div style={{color: '#cb2b2b'}}><i className="fa fa-warning"/> This task was performed below
                    standards.</div>
                )}
              </Fragment>
            )}
            <div className="form blank-form">
              <FormGroup>
                <Input
                  onChange={event => this.props.updateComment(event.target.value)}
                  value={this.props.ackComment}
                  type="textarea"
                  placeholder="Comment"
                />
              </FormGroup>
            </div>
            {this.props.userContext && this.props.userContext.hasScope('oit') ?
              <div style={{fontSize: '0.8em'}}>
                I acknowledge that I have reviewed and fully understand all of the details of this form and I am
                comfortable appropriately executing this training experience
              </div>
              : <div style={{fontSize: '0.8em'}}>
                I have reviewed this task and acknowledge its completion by the recruit
              </div>}
            <div className="action-ack">
              <LoadingButton
                small
                defaultClass
                icon="fa fa-thumbs-up"
                text="Acknowledge task"
                onClick={() => this.props.onAck(this.taskResponse)}
                isLoading={this.props.isLoading}
              />
            </div>

            {this.taskGroup && this.taskGroup.taskGroupDescription &&
              <div className="reference-material-link">
                <span
                  onClick={() => this.showReferenceMaterial(this.taskResponse)} >
                  Review before signing
                </span>
              </div>
            }
          </div>
        )}

        {this.taskGroup &&
          <Modal
            title="Reference Material"
            isOpen={this.state.isModalOpen}
            onClose={() => this.setState({ isModalOpen: false })}
          >
            <div className="reference-material-container">
              {this.taskGroup.taskGroupDescription}
            </div>
          </Modal>
        }
      </div>
    );
  }
}

export default DashboardTasks;
